import { ComponentType } from 'react'
import classNames from 'classnames'

import type { Option } from '../../00-Primitives/Inputs/Dropdown'
import Dropdown from '../../00-Primitives/Inputs/Dropdown'
import style from './style.scss'

type Props = {
  className?: string
  onChange: (value: string) => void
  labelText: string
  options: Option[]
  selectedOption?: string
  Icon: ComponentType<{ className?: string }>
}

function FilterDropdown({
  onChange,
  className,
  labelText,
  options,
  selectedOption,
  Icon,
}: Props) {
  return (
    <Dropdown
      className={classNames(style.wrapper, className)}
      handleOptionChange={onChange}
      iconNode={<Icon className={style.icon} />}
      inputId={labelText}
      label={labelText}
      options={options}
      selectedOption={selectedOption}
      variant='tertiary'
    />
  )
}

export default FilterDropdown
